import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  const filled = 327;
  const total = 500;
  const pct = Math.round(filled / total * 100);
  return <section className="py-20 bg-white px-4" data-id="element-91">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-92">
        {/* Urgency Block */}
        <div className="bg-[#9B4D4D] text-white rounded-2xl p-8 md:p-10 text-center" data-id="element-93">
          <p className="text-sm font-bold uppercase tracking-wider text-white/70 mb-3" data-id="element-94">
            ⏳ Oferta disponible por tiempo limitado
          </p>
          <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto" data-id="element-95">
            El precio promocional de $11.99 USD puede cambiar en cualquier
            momento. Descarga hoy tu ebook y obtén los 2 bonos digitales
            incluidos GRATIS.
          </p>

          {/* Progress bar */}
          <div className="max-w-sm mx-auto mb-6" data-id="element-96">
            <div className="flex justify-between text-xs text-white/60 mb-1.5" data-id="element-97">
              <span data-id="element-98">{filled} accedieron</span>
              <span data-id="element-99">{total} cupos</span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-3 overflow-hidden" data-id="element-100">
              <div className="bg-gradient-to-r from-red-400 to-red-500 h-3 rounded-full transition-all" style={{
              width: `${pct}%`
            }} data-id="element-101" />
            </div>
            <p className="text-xs text-white/50 mt-1.5" data-id="element-102">
              Quedan {total - filled} cupos al precio de lanzamiento
            </p>

            <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="mt-5 inline-block w-full sm:w-auto rounded-full bg-[#C4973B] px-8 py-3.5 text-base font-bold text-white shadow-lg hover:bg-[#B08632] hover:scale-105 transition-all" data-id="element-103">
              👉 QUIERO MI LUGAR AL PRECIO DE LANZAMIENTO →
            </a>
          </div>

          <div data-id="element-104">
            <p className="text-sm text-white/50 line-through mb-1" data-id="element-105">
              Valor Total: $75
            </p>
            <p className="text-4xl font-bold" data-id="element-106">Hoy: $11.99</p>
            <p className="text-sm text-[#C4973B] font-semibold mt-1" data-id="element-107">
              Ahorras $63 hoy (84% descuento)
            </p>
            <p className="text-white/70 text-sm mt-1" data-id="element-108">
              📲 Acceso inmediato · Formato PDF descargable
            </p>
          </div>
        </div>

        {/* Price comparison */}
        <div className="grid grid-cols-3 gap-4 text-center" data-id="element-109">
          {[{
          label: 'Sesión de terapia',
          price: '$80–150',
          note: 'una vez'
        }, {
          label: 'Ebook Calma',
          price: '$11.99',
          note: 'de por vida',
          highlight: true
        }, {
          label: 'Café en una semana',
          price: '$15–25',
          note: 'se acaba'
        }].map((item, i) => <div key={i} className={`rounded-xl p-5 border ${item.highlight ? 'bg-[#FAF5EF] border-[#C4973B]/40 shadow-md' : 'bg-gray-50 border-gray-200'}`} data-id="element-110">
              <p className={`text-xl font-bold mb-1 ${item.highlight ? 'text-[#C06B6B]' : 'text-gray-700'}`} data-id="element-111">
                {item.price}
              </p>
              <p className="text-sm text-gray-600 font-medium" data-id="element-112">{item.label}</p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-113">{item.note}</p>
            </div>)}
        </div>
        <p className="text-center text-[#C06B6B] font-semibold -mt-6" data-id="element-114">
          Y lo usas hoy mismo.
        </p>

        {/* Guarantee */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-115">
          <ShieldCheck className="h-16 w-16 text-[#C06B6B] mx-auto mb-6" data-id="element-116" />
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4" data-id="element-117">
            Tu tranquilidad mental vale la pena
          </h2>
          <p className="text-lg text-gray-600" data-id="element-118">
            Empieza hoy mismo a aplicar las técnicas del ebook y descubre
            herramientas simples para recuperar calma mental y reducir ansiedad
            diaria.
          </p>
          <p className="text-lg font-medium text-gray-800 mt-2" data-id="element-119">
            Acceso inmediato después de tu compra.
          </p>
        </div>
      </div>
    </section>;
}